module.exports = __webpack_public_path__ + "img/news-7.f3e3882c.jpeg";